import React, {Component} from 'react';

import { Responsive, Container } from 'semantic-ui-react';
import { Link } from "react-router-dom";
import Logo from './img/logo.png';
import RCCLogo from './img/rcclogo.png';
import CARING from './img/caring.png';
import LoginForm from '../decoration/loginform';
import Modal from 'react-responsive-modal';
import cookie from 'react-cookies';
import {HashLink} from 'react-router-hash-link';

const brandName = "Rotary Club Central";
const burger = (<i className="fas fa-bars"></i>);

class Header extends Component {

    state = {open: false, isLogin:false}
    onOpenModal = () => {
        this.setState({ open: true });
      };

      onCloseModal = () => {
        this.setState({ open: false });
      };
      handleLogout = () =>{
        cookie.save('userId', "", { path: '/' });
        window.location.href = '/';
      }
      handleDashBoard = () =>{
        window.location.href = '/dashboard';
      }
    handlePrimaryMenu = () =>{
      let menu = document.querySelector('#monza-site-navigation');
      if (menu.className==="monza-main-navigation")
        menu.className = "monza-main-navigation toggled";
      else
        menu.className = "monza-main-navigation";
    }

    componentDidMount(){
      var userId = cookie.load("userId");
      if (userId!==undefined)
        if (userId!==""){
          this.setState({
            isLogin:true
          })
        }
    }
    render() {
      return (
        <header className='monza-site-header' id='monza-masthead'>
        <div>
        <Modal open={this.state.open} onClose={this.onCloseModal} center>
                  <LoginForm />
                </Modal>
        <div className='monza-site-branding'>
        <div className='siteheaderwarea section' id='siteheaderwarea' name='Header'>
        <div className='widget' data-version='1' id='Header1'>

        <div id='header-inner'>
        <div className='titlewrapper'>
        <h1 className='monza-site-title'>
          <img className="Logo-new" src={Logo} alt=""/>
          <Link to='/'>Rotary club of Central</Link>
          <img className="Rcc" src={RCCLogo} alt=""/>
        </h1>
        </div>
        <p className='monza-site-description'>
        </p>
        </div>
        </div></div>
        </div>
        </div>

        <nav className='monza-main-navigation' id='monza-site-navigation'>
        <div className="HeaderContainer">
        <button aria-controls='monza-primary-menu' aria-expanded='false' className='monza-menu-toggle' onClick={this.handlePrimaryMenu}><span className='monza-menu-toggle-close-text'>Close </span>Primary Menu</button>
        <div className='monza-menu-container'>
        <ul className='monza-menu nav-menu' id='monza-primary-menu'>
        <li><Link to='/'>Home</Link></li>
        <li><Link to='/aboutus'>ABOUT US</Link>
        <ul className='sub-menu'>
        <li><Link to='/whatisrotary'>What is Rotary</Link></li>
        <li><Link to='/aboutus'>About Rotary Club Of Central</Link></li>
        <li><Link to='/corevalue'>Our Core Value&#160;</Link></li>
        <li><Link to='/boardmember'>Board Member List</Link></li>
        <li><Link to='/memberlist'>Member List</Link></li>
        <li><Link to='/pastpresidentslist'>Past Presidents List</Link></li>
        </ul>
        </li>
        <li><a href='#'>GET INVOLVED</a>
        <ul className='sub-menu'>
        <li><Link to="/regularmeeting">Regular Meetings</Link></li>
        <li><Link to="/serviceprojects">Service Project</Link></li>
        <li><Link to="/fellowshipevents">Fellowship Event</Link></li>
        <li><Link to="/beourmember">Be our Member</Link></li>
        </ul>
        </li>
        <li><a href='#'>OUR SERVICES</a>
        <ul className='sub-menu'>
          <li><Link to="/makeit">Year 2009-2014 Make it Series</Link>
        {/*<ul className='sub-menu'>*/}
        {/*  <li><HashLink to="/makeit#make-a-wish-2009">Make A WISH(2009-2010)</HashLink></li>*/}
        {/*  <li><HashLink to="/makeit#make-it-real-2010">Make It REAL(2010-2011)</HashLink></li>*/}
        {/*  <li><HashLink to="/makeit#make-it-shine-2011">Make It SHINE(2011-2012)</HashLink></li>*/}
        {/*/!*<li><Link to="/makeIt#make-it-one-2012">Make It ONE(2012-2013)</Link></li>*!/*/}
        {/*  <li><HashLink to="/makeit#make-it-rich-2013">Make It RICH(2013-2014)</HashLink></li>*/}
        {/*  <li><HashLink to="/makeit#make-a-smile-2016">Make a SMILE(2016-2017)</HashLink></li>*/}
        {/*</ul>*/}
        </li>
          <li><Link to="/districtmentorshipprogram">Year 2015-2016 District Mentorship Program</Link></li>
          <li><a href='/rev'>Year 2016-Now Regular Elderly Visit </a></li>
          <li><Link to="/makeasmile">Year 2016-2017 Make a Smile</Link></li>
          <li><Link to="/hkdsa">Year 2017-2019 Services with HKDSA</Link></li>
          <li><Link to="/internationalservices">Year 2012-2018 International Services</Link></li>
          <li><Link to="/guinnesswr">Year 2017-2018 Breaking Guinness World Record</Link></li>
          <li><Link to="/smartpeopleliving">Year 2018-2019 Smart People Living & Earth</Link></li>
          <li><Link to="/r-intelligence">Year 2019-2020 R-Intelligence</Link></li>
          <li><Link to="/adopt-a-school">Year 2019-2020 Adopt-A-School Service Project</Link></li>
          <li><Link to="/rcc">Year 2021-2022 RCC 屯門天主教中學助學金計劃</Link></li>
          <li><Link to="/paktinest">Year 2021-2022 白田邨新居入伙禮包派贈日</Link></li>

          {/*<li><a href='#'>Adopt A School</a></li>*/}
        <li><a href='kid'>Kideract Club of Central</a></li>
        <li><a href='rotaract'>Rotaractor Club of Central</a></li>
        </ul>
        </li>
        <li><Link to='/news'>NEWS</Link></li>
        <li><a href='/events'>EVENT</a></li>
        <li><a href='/centraltimes'>Central Times</a></li>
        <li><a href='#' onClick={this.state.isLogin?(this.props.page==="dashboard"?this.handleLogout:this.handleDashBoard):this.onOpenModal}>{this.state.isLogin?(this.props.page==="dashboard"?"LOGOUT":"DASHBOARD"):"LOGIN"}</a></li>
        <li><a href='/photos'>PHOTOS</a></li>
        <li><a href='/contactus'>CONTACT US</a></li>

        </ul>
        </div>
        </div>
        </nav>
        </header>

      );
    }
}

export default Header;
